<template>
  <div class="tableWithPerPageSelection">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('listeTitreRecette.title') }}
              </h1>
              <breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="columns is-gapless">
            <div class="column">
              <dropdown-button
                type="is-addOrEdit"
                :permission="constantes.TITRE_RECETTE.maj"
                :actions="actionsButton"
                @click="() => $router.push({name: 'm.gabed.titre_recette-ajout'})">
                {{ $t('listeTitreRecette.actions.addTitreRecette')}}
              </dropdown-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <store-recherche-provider
      key="titreRecette"
      :name="constantes.storeName"
      :copy="factureAchatARapprocherStore"
      :copyChanges="changesFactureTlpeStore">
      <liste-facture-achat
        :permFactureAchat="permFactureAchat"
        :referenceTable="referenceTable"
        :nameStore="constantes.storeName"
        :moduleDcf="constantes.MODULE_TLPE"
        :baseTraduction="'listeTitreRecette'"
      />
    </store-recherche-provider>
  </div>
</template>

<script>
import factureAchatARapprocherStore from '@/store/modules/baux/factureAchatARapprocher';
import { createNamespacedHelpers } from 'vuex';
import listeFactureAchat from '@/components/factures/listeFactureAchat';
import genererCritereRechercheTitreRecette from '@/services/gabed/titreRecette/genererCritereRechercheTitreRecette';
import { TITRE_RECETTE } from '@/configuration/gabed/permissionsGabedConf';
import { REFERENCE_TABLE_LISTE_TITRE_RECETTE } from '@/configuration/general/referenceTableConf';
import breadcrumb from '@/components/general/breadcrumb';
import { TIERS_TYPE_FOURNISSEUR, TIERS_SOUS_TYPE_COLLECTIVITE } from '@/configuration/tiers/tiersConf';
import { MODULE_TLPE } from '@/configuration/devisConf';
import storeRechercheProvider from '@/components/general/store/storeRechercheProvider';
import { TITRE_RECETTE_STORE } from '@/configuration/gabed/tlpe/tlpeConf';
import * as allTypes from '@/store/mutation-type';
import dropdownButton from '@/components/general/button/dropdownButton';

const Permissions = createNamespacedHelpers('permissions');

export default {
  name: 'factureAchatTlpe',
  components: {
    dropdownButton,
    listeFactureAchat,
    breadcrumb,
    storeRechercheProvider,
  },
  data() {
    return {
      permFactureAchat: TITRE_RECETTE,
      referenceTable: REFERENCE_TABLE_LISTE_TITRE_RECETTE,
      constantes: {
        TIERS_TYPE_FOURNISSEUR,
        TIERS_SOUS_TYPE_COLLECTIVITE,
        MODULE_TLPE,
        storeName: TITRE_RECETTE_STORE,
        TITRE_RECETTE,
      },
      factureAchatARapprocherStore,
      actionsButton: [{
        label: this.$t('listeFactures.actions.newCreditNote'),
        action: () => this.$router.push({ name: 'm.gabed.titre_recette-save-to-edit-avoir' }),
      }],
    };
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    breadcrumb() {
      return [
        { title: this.$t('listeTitreRecette.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('listeTitreRecette.breadcrumb.listeTitreRecette'), route: '', isActive: true },
      ];
    },
    critereRechecheInit() {
      return genererCritereRechercheTitreRecette();
    },
    changesFactureTlpeStore() {
      return {
        state: {
          items: [],
          total: 0,
          criteresRecherche: genererCritereRechercheTitreRecette(),
          lastPayload: {},
        },
        mutations: {
          [allTypes.RESET_STATE](state) {
            const s = {
              items: [],
              total: 0,
              criteresRecherche: genererCritereRechercheTitreRecette(),
              lastPayload: {},
            };
            Object.keys(state).forEach(key => {
              state[key] = s[key];
            });
          },
        },
      };
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
  },
  mounted() {
    this.setInformationPage(this.$t('pagePatrimoine.titreRecette.liste'));
  },
};
</script>
